<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'stock'"
          @itemChange="(e) => (selectedStock = e)"
          :label="'Stok'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue"
          label="Grup Kodu"
          :items="groupCodeList"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue1"
          label="Kod 1"
          :items="groupCodeList1"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue2"
          label="Kod 2"
          :items="groupCodeList2"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue3"
          label="Kod 3"
          :items="groupCodeList3"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue4"
          label="Kod 4"
          :items="groupCodeList4"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue5"
          label="Kod 5"
          :items="groupCodeList5"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          :items="companyList"
          item-text="name"
          item-value="name"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import { mapActions,mapState } from "vuex";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "StokAnaliz",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.getCodesList();
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    })
  },
  computed:{
    ...mapState("company",["companyList"]),
    ...mapState("auth",["user"])
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      stockSearchResult:[],
      searchStockTimeout: null,
      selectedStock: null,
      stockSearchText:"",
      searchStockLoading: false,
      groupCodeList:[],
      groupCodeList1:[],
      groupCodeList2:[],
      groupCodeList3:[],
      groupCodeList4:[],
      groupCodeList5:[],
      groupCodeValue:null,
      groupCodeValue1:null,
      groupCodeValue2:null,
      groupCodeValue3:null,
      groupCodeValue4:null,
      groupCodeValue5:null,
      reportDbName:null
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  methods:{
    ...mapActions("company", ["fetchCompanyList"]),
    ...mapActions("stock", ["fetchStockList","fetchStockCodes"]),
    formattedDate,
    validationMessages,
    async searchStockList() {
      this.stockSearchResult = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: this.stockSearchText,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      });
      this.searchStockLoading = false

    },
    async getCodesList(){
      let codeList = [1,2,3,4,5,6];
      for (let i = 0; i < codeList.length; i++) {
        let requestParams = {};
            requestParams.params = {tableType: codeList[i]};
            requestParams.body = {}
        let result = await this.fetchStockCodes(requestParams);
        switch (codeList[i]){
          case 1:
            this.groupCodeList = result;
            break;
          case 2:
            this.groupCodeList1 = result;
            break;
          case 3:
            this.groupCodeList2 = result;
            break;
          case 4:
            this.groupCodeList3 = result;
            break;
          case 5:
            this.groupCodeList4 = result;
            break;
          case 6:
            this.groupCodeList5 = result;
            break;

        }
      }
    },
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          StockCode: this.selectedStock,
          StockGroupCode: this.groupCodeValue,
          StockCode1: this.groupCodeValue1,
          StockCode2: this.groupCodeValue2,
          StockCode3: this.groupCodeValue3,
          StockCode4: this.groupCodeValue4,
          StockCode5: this.groupCodeValue5,
          ReportDbName: this.reportDbName
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    }
  },
  watch: {
    stockSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        this.stockSearchResult = [];
        if(this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);
        this.searchStockLoading = true
        this.searchStockTimeout = setTimeout(() => {

          this.searchStockList();

        },2000);
      }
    }
  }
}
</script>

<style scoped>

</style>